/**
 * reconcile.js (service) — fetch the scheduler-untouchable "stuck" items and execute the pre-canned
 * one-tap shortcuts. The registry + detectors live in outline/reconcile.js (pure); this is the data +
 * write layer. Add a kind: fetch its raw set in getReconcileItems and add an executor branch in
 * runReconcileAction. The 'open' action is navigation (handled by the caller), not a write.
 */

import { apiGet } from './_api.js'
import { updateMilestoneLft } from './milestones.js'
import { normalizeReactiveOverdue } from '../outline/reconcile.js'
import { isoToday } from './work.js'

const TBL_DEL = 'tblFuiDpahqCL4eIK'

/** All items the scheduler can't resolve on its own, normalized for the Reconcile lane. */
export async function getReconcileItems() {
  // Reactive = Days Budgeted 0 (outside party's clock), past due, not posted. Active-only filtered in normalize.
  const reactiveRaw = await apiGet(
    TBL_DEL,
    'filterByFormula=' + encodeURIComponent("AND({Days Budgeted}=0, {Posted Date}='', IS_BEFORE({Latest Finish (LFT)}, TODAY()))") + '&maxRecords=200',
  ).catch(() => [])
  const items = normalizeReactiveOverdue(reactiveRaw)
  // FUTURE: concat pinned-overdue, overdue threads, blocked-by-overdue here.
  return items
}

function plusDays(ymd, n) {
  const d = new Date((ymd || isoToday()) + 'T12:00:00')
  d.setDate(d.getDate() + n)
  return d.toISOString().slice(0, 10)
}

/** Execute a pre-canned reconcile shortcut (a real write). 'open' is navigation, handled by the caller. */
export async function runReconcileAction(item, actionId) {
  if (item.kind === 'reactive_overdue') {
    if (actionId === 'extend_2w') return updateMilestoneLft(item.entityId, plusDays(item.due, 14))
  }
  throw new Error('Unknown reconcile action: ' + actionId + ' for ' + item.kind)
}
